module.exports = __webpack_public_path__ + "img/occ_r_img.cd5d344f.png";